import type { ChangelogEntry } from "../types";

/**
 * Cold call-arket flyttes inn i Revehiet: lister per booker, prioritet, vinkel,
 * manus og to nye utfall på leadkortet.
 */
export const COLD_CALL_ARKET_2026_11: ChangelogEntry = {
  id: "2026-11-02-cold-call-arket",
  date: "2026-11-02",
  title: "Cold call-listene ligger nå i Leads",
  summary: "Listene fra cold call-arket er flyttet inn, med siste utfall, og hver booker får sine egne leads.",
  sections: [
    {
      heading: "Leads",
      items: [
        {
          title: "Egne lister per booker",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "En leadliste kan ha en eier. Eieren får bare leads fra sine egne lister, og får Leads selv om rollen ellers ikke har det. Eieren velges i Leadlister.",
        },
        {
          title: "Prioritet, vinkel og manus på leadkortet",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Leadkortet viser prioritet (A ringes først), hvorfor selskapet er relevant, notat og om nummeret er usikkert. Har listen et manus, ligger det på kortet.",
        },
        {
          title: "Sendt e-post og Feil nummer",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "To nye utfall: «Sendt e-post» (5) gir deg leadet igjen om en uke, og «Feil nummer» (6) setter det til side i 30 dager.",
        },
        {
          title: "Avviste leads vurderes på nytt",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "«Ikke relevant» spør nå om årsak og når leadet skal vurderes på nytt, med 6 måneder som standard. Under «Avviste» i Leadlister ligger leadene som har nådd datoen, og de kan sendes tilbake i køen, utsettes eller avsluttes for godt.",
        },
      ],
    },
  ],
};
